import { render, staticRenderFns } from "./KnowledgeActivityDetail.vue?vue&type=template&id=3a6eea03"
import script from "./KnowledgeActivityDetail.vue?vue&type=script&lang=js"
export * from "./KnowledgeActivityDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports